export default __webpack_public_path__ + "static/media/basket-example.603cd3ec.png";